<template>
  <div class="login-container">
    <header>
      <img style="margin-top: 0px;width: 600px;height: 84px;" src="../../assets/changchenglogo2.png" alt="">
    </header>
    <img class="backimg" src="../../assets/c_bei.png" alt="">
    <div class="forget-content">
      <!-- <h3> 忘记密码</h3> -->
      <!-- <div class="xian"></div> -->
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="手机号码" prop="name">
          <el-input placeholder="请输入手机号码" oninput="value=value.replace(/[^0-9]/g,'')" v-model="ruleForm.name"></el-input>
        </el-form-item>
        <el-form-item label="短信验证码" prop="yzm">
          <div style="display:flex;">
            <el-input style="margin-right:5px;" placeholder="请输入您收到的短信验证码" v-model="ruleForm.yzm"></el-input>
            <div style="display:flex;">
              <!-- <el-input style="margin-right:5px;" placeholder="请输入您收到的短信验证码" v-model="ruleForm.name1"></el-input> -->
              <!-- <div class="get-captcha-btn" @click="getCaptcha($event)"
                :style="{ backgroundColor: isCounting ? '#DCB780' : '#DCB780', color: isCounting ? '#fff' : '#fff' }">
                {{ isCounting ? countdownText : '获取验证码' }}
              </div> -->
              <div style="display:flex;">
                            <el-button  class="get-captcha-btn"  @click="getCaptcha($event)" :disabled="isCaptchaButtonDisabled"  :style="{ backgroundColor: isCounting ? '#DCB780' : '#DCB780', color: isCounting ? '#fff' : '#fff' }">
                            <!-- <div class="get-captcha-btn" @click="getCaptcha($event)"
                                :style="{ backgroundColor: isCounting ? '#DCB780' : '#DCB780', color: isCounting ? '#fff' : '#fff' }"> -->
                               <span style="display: flex;justify-content: center;font-size: 14px;">{{ isCounting ? countdownText : '获取验证码' }}</span> 
                            <!-- </div> -->
                        </el-button>
                        </div>
            </div>
          </div>
        </el-form-item>
        <!-- <el-form-item label="新密码" prop="name2">
          <el-input placeholder="请设置新登录密码" v-model="ruleForm.name2"></el-input>
        </el-form-item> -->
        <el-form-item label="新密码" prop="password">
          <el-input v-model="ruleForm.password" @input="password()" placeholder="请输入密码"></el-input>
          <div class="input_span">
            <span
              :style="{ 'background': (msgText > 1 || msgText == 1) ? '#FC5F76' : '#ccc', 'color': (msgText > 1 || msgText == 1) ? '#FC5F76' : '#BBB' }">弱</span>
            <span
              :style="{ 'background': (msgText > 2 || msgText == 2) ? '#FF9900' : '#ccc', 'color': (msgText > 1 || msgText == 1) ? '#FF9900' : '#BBB' }">中</span>
            <span
              :style="{ 'background': (msgText > 4 || msgText == 4) ? '#33CC00' : '#ccc', 'color': (msgText > 1 || msgText == 1) ? '#33CC00' : '#BBB' }">强</span>
          </div>
        </el-form-item>
        <p style="font-size:15px;margin-top:34px;margin-left:80px;color:gray">提示：请输入8-16位，至少包含大写字母、小写字母、数字3种</p>
        <!-- <el-form-item label="确认新密码" prop="name3" style="margin-top: 20px;">
          <el-input placeholder="请再次输入新登录密码" v-model="ruleForm.name3"></el-input>
        </el-form-item> -->
        <el-form-item label="确认新密码" prop="password1" style="margin-top: 20px;">
          <el-input v-model="ruleForm.password1" @input="password1()" placeholder="请输入密码"></el-input>
          <div class="input_span">
            <span
              :style="{ 'background': (msgText1 > 1 || msgText1 == 1) ? '#FC5F76' : '#ccc', 'color': (msgText1 > 1 || msgText1 == 1) ? '#FC5F76' : '#BBB' }">弱</span>
            <span
              :style="{ 'background': (msgText1 > 2 || msgText1 == 2) ? '#FF9900' : '#ccc', 'color': (msgText1 > 1 || msgText1 == 1) ? '#FF9900' : '#BBB' }">中</span>
            <span
              :style="{ 'background': (msgText1 > 4 || msgText1 == 4) ? '#33CC00' : '#ccc', 'color': (msgText1 > 1 || msgText1 == 1) ? '#33CC00' : '#BBB' }">强</span>
          </div>
        </el-form-item>
        <p style="font-size:15px;margin-top:34px;margin-left:80px;color:gray">提示：请输入8-16位，至少包含大写字母、小写字母、数字3种</p>

        <el-form-item>
          <el-button style="width:100%;background: #DCB780;border: none;margin-top: 20px;font-size: 19px;"
            type="primary" @click="submitForm('ruleForm')">提交</el-button>
          <!-- <el-button @click="resetForm('ruleForm')">重置</el-button> -->
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>

import { updatePwdCode, updatePwd,check } from '../../request/api'
export default {
  data() {
    return {
      msgText: "",
      msgText1: "",
      iconclass: {
        color: '#BBB',
        fontSize: '16px'
      },
      ruleForm: {
        name: '',
        password: '',
        password1: '',
        date2: '',
        delivery: false,
        type: [],
        resource: '',
        desc: '',
        yzm: '',
        contactPhone:''
      },
      isCaptchaButtonDisabled: false,

      rules: {
        name: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '手机号格式不正确', trigger: 'blur' }

        ],
        yzm: [
          { required: true, message: '请输入短信验证码', trigger: 'blur' },

        ],
        password: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
        ],
        password1: [
          { required: true, message: '请再次输入新密码', trigger: 'blur' },
          { validator: this.validatePassword, trigger: 'blur' }
          // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
        ],

      },
      isCounting: false, // 是否在倒计时
      countdown: 60,     // 倒计时秒数
      countdownText: '', // 倒计时文本
      timer: "",
      username: ''
    };
  },
  watch: {
    'ruleForm.password': {
      handler(keyWord, oldname) {
        // console.log("keyWord:", keyWord)
        this.msgText = this.checkStrong(keyWord);
      }
    },
    'ruleForm.password1': {
      handler(keyWord, oldname) {
        // console.log("keyWord:", keyWord)
        this.msgText1 = this.checkStrong(keyWord);
      }
    }
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  created() {
    const savedTime = localStorage.getItem('captchaCountdown');
    const startTime = localStorage.getItem('captchaStartTime');

    if (savedTime && startTime) {
      // 计算已经过去的时间
      const elapsedSeconds = Math.floor((Date.now() - parseInt(startTime)) / 1000);
      const remaining = parseInt(savedTime) - elapsedSeconds;

      if (remaining > 0) {
        this.countdown = remaining;
        this.isCounting = true;
        this.startCountdown();
      } else {
        this.resetCountdown();
      }
    }
    if (this.ruleForm.password) {
      this.msgText = this.checkStrong(this.ruleForm.password);
    }

    // this.datalist()
  },
  methods: {
    validatePassword(rule, value, callback) {
      if (value !== this.ruleForm.password) {
        callback(new Error('两次输入的密码不一致!'));
      } else {
        callback();
      }
    },
    checkStrong(sValue) {
      var modes = 0;
      //正则表达式验证符合要求的
      if (sValue.length < 1) return modes;
      if (/\d/.test(sValue)) modes++; //数字
      if (/[a-z]/.test(sValue)) modes++; //小写
      if (/[A-Z]/.test(sValue)) modes++; //大写
      if (/\W/.test(sValue)) modes++; //特殊字符
      // console.log("modes:", sValue.length, modes)
      //逻辑处理
      switch (modes) {
        case 1:
          return 1;
          break;
        case 2:
          return 2;
          break;
        case 3:
        case 4:
          return sValue.length < 4 ? 3 : 4;
          break;
      }
      return modes;
    },
    password() {
      const password = this.ruleForm.password;
      let strength = '弱';

      if (password.length >= 8) {
        if (/(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]/.test(password)) {
          strength = '强';
        } else if (/(?=.*[a-z])(?=.*[A-Z])|(?=.*[a-z])(?=.*\d)|(?=.*[A-Z])(?=.*\d)/.test(password)) {
          strength = '中';
        }
      }

      // passwordStrength.textContent = strength;
    },
    password1() {
      const password = this.ruleForm.password1;
      let strength = '弱';

      if (password.length >= 8) {
        if (/(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]/.test(password)) {
          strength = '强';
        } else if (/(?=.*[a-z])(?=.*[A-Z])|(?=.*[a-z])(?=.*\d)|(?=.*[A-Z])(?=.*\d)/.test(password)) {
          strength = '中';
        }
      }

      // passwordStrength.textContent = strength;
    },
    submitForm(formName) {
      console.log(formName, 'submit!!');

      this.$refs[formName].validate((valid) => {
        if (valid) {

         
            
              let param = {
                newPassword: this.ruleForm.password,
                userName: this.username,
                phone: this.ruleForm.name,
                code: this.ruleForm.yzm
              }
              updatePwd(param).then(res => {
                if (res.code == 200) {
                  this.$message.success('修改成功！');
                  this.$router.push('/login')
                } else {
                  this.$message.error(res.msg);
                }
              })
           
          





          // alert('submit!');

        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    getCaptcha(event) {
      event.preventDefault();
      this.$refs.ruleForm.validateField('name', (valid) => {
        if (!valid) { // ，valid为false表示验证通过

          updatePwdCode(this.ruleForm.name).then(res => {
            if (res.code === 200) {
              this.$message.success('验证码已发送，请注意查收！');
              this.isCaptchaButtonDisabled = true;

              this.username = res.msg;
            } else {
              this.$message.error(res.msg);
            }

          });
          if (!this.isCounting) {
            this.startCountdown();
          }
        } else {
          console.error('手机号格式不正确，请重新输入');
        }
      });
    },

    startCountdown() {
      // 从本地存储获取剩余时间，如果没有则为60秒
      const savedTime = localStorage.getItem('captchaCountdown');
      this.countdown = savedTime ? parseInt(savedTime) : 60;

      this.isCounting = true;
      this.updateCountdownText();

      // 存储开始时间戳
      localStorage.setItem('captchaStartTime', Date.now().toString());
      localStorage.setItem('captchaCountdown', this.countdown.toString());

      this.timer = setInterval(() => {
        this.countdown--;
        this.updateCountdownText();
        localStorage.setItem('captchaCountdown', this.countdown.toString());

        if (this.countdown <= 0) {
          this.resetCountdown();
        }
      }, 1000);
    },

    updateCountdownText() {
      this.countdownText = this.countdown + '秒';
    },

    resetCountdown() {
      clearInterval(this.timer);
      this.isCounting = false;
      this.countdown = 10;
      this.countdownText = '获取验证码';
      localStorage.removeItem('captchaStartTime');
      localStorage.removeItem('captchaCountdown');
      this.isCaptchaButtonDisabled = false;
    },
  }
}
</script>
<style scoped lang="scss">
.login-container {
  width: 100%;
  height: 100%;
}

::v-deep .el-input__icon {
  font-size: 20px !important;
}

::v-deep .el-tabs__active-bar {
  background-color: #DCB780;
  /* 例如 #ff0000 是红色 */
}

::v-deep .el-input__inner {
  background: rgba(0, 0, 0, 0.06) !important;
  border: none;
  border-radius: 8px;
}

::v-deep .is-active {
  color: black !important;
}

::v-deep .el-tabs__nav {
  width: 100%;

}

::v-deep .el-tabs__active-bar {
  width: 50% !important;
  text-align: center;
}

::v-deep .el-tabs__item {
  margin-right: 0px;
  font-size: 18px;
}

::v-deep #tab-second {
  margin-left: 70px;
}

header {
  width: 100%;
  height: 80px;
  font-size: 30px;
  color: #C49958;
  background-color: #F1F1F1;
  line-height: 80px;
}

.backimg {
  display: block;
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
}

.content {
  width: 880px;
  display: flex;
  margin: 0 auto;
  text-align: center;
  align-items: center;


  img {
    display: block;
    width: 448px;
    height: 539px;
    // padding-left: 432px;
    padding-top: 108px;
    margin-left: -38px;
    z-index: 9999 !important;
  }

  .tabs {

    margin-top: 98px;
    margin-left: 65px;

    .el-input {
      width: 340px;
      height: 50px;
      display: block;
      margin-top: 10px;
    }

    .el-button {
      width: 360px;
      height: 50px;
      background: linear-gradient(180deg, #DCB780 0%, #C49958 100%);
      margin-top: 10px;
      border: none;
    }

    ul {

      width: 240px;
      display: flex;
      margin: 20px auto;
      justify-content: space-between;

      li {
        color: #C49958;
        cursor: pointer;
      }
    }
  }
}

::v-deep .el-tabs__nav-wrap::after {
  display: none;
}

.forget {
  width: 100%;
  height: 100vh;
  background-color: #e5f1e8e1;
  display: flex;
  /* 启用Flexbox布局 */
  justify-content: center;
  /* 水平居中 */
  align-items: center;
}

.forget-content {
  width: 800px;
  height: 500px;
  background: white;
  margin: 100px auto;

  h3 {
    text-align: left;
    margin-left: 20px;
    margin-top: 10px;
  }

  .xian {
    width: 100%;
    height: 1px;
    background-color: #e5f1e8e1;
    margin-top: 10px;
  }
}

.demo-ruleForm {
  width: 70%;
  margin: 30px auto;
}

.get-captcha-btn {
  width: 94px;
  height: 40px;
  background: #DCB780;
  font-size: 14px;
}

::v-deep .el-form-item__label {
  font-size: 18px;
  width: 115px !important;

  // margin-top: 5px;
}

::v-deep .el-input {
  width: 95%;
}

.input_span {
  height: 8px;
  display: flex;
  // float: right;
  width: 35%;
  margin-top: 10px;
  margin-left: 20px;

  span {
    display: inline-block;
    width: 30%;
    border-radius: 8px;
    margin-right: 3px;
    text-align: center;
    margin-top: 3px;
    height: 2px;
    background: rgba(0, 0, 0, 0.02);
  }
}

::v-deep .el-form-item__error {
  margin-left: 18px !important;
}

::v-deep .el-form-item__label:before {
  display: none !important;
}
</style>